import { render, staticRenderFns } from "./tiktokVideoItem.vue?vue&type=template&id=ed646fdc"
import script from "./tiktokVideoItem.vue?vue&type=script&lang=js"
export * from "./tiktokVideoItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports